export default __webpack_public_path__ + "5cbeeceb2e81019c33720fe5525c0117.svg";